import React from "react";
import {useParams} from "react-router-dom";
import useEventCityGet from "../../modules/eventCities/hooks/useEventCityGet";
import PublicLayout from "../../modules/ui/components/PublicLayout";
import BgGlassmorphism from "../../modules/ui/components/BgGlassmorphism/BgGlassmorphism";
import HotelMainInfoCard from "./HotelMainInfoCard";
import useCustomerContext from "../../modules/customers/hooks/useCustomerContext";
import useHotelDetailsGet from "../../modules/hotels/hooks/useHotelDetailsGet";
import HotelImagesGallery from "./HotelImagesGallery";
import HotelSectionHero from "./HotelSectionHero";
import HotelAmenitiesCard from "./HotelAmenitiesCard";
import HotelLocationCard from "./HotelLocationCard";
import HotelInformationAndExtrasCard from "./HotelInformationAndExtrasCard";
import HotelCancellationPolicyCard from "./HotelCancellationPolityCard";
import HotelRoomCard from "./HotelRoomCard";
import useHotelCategoriesGetAll from "../../modules/hotels/hooks/useHotelCategoriesGetAll";
import useHotelGetRoomsInfo from "../../modules/hotels/hooks/useHotelGetRoomsInfo";
import useBookingSearchContext from "../../modules/booking/hooks/useBookingSearchContext";
import HotelExtraInfoCard from "./HotelExtraInfoCard";
import Loader from "modules/ui/shared/Loader/Loader";
import useHotelGet from "../../modules/hotels/hooks/useHotelGet";
import useHotelGetRoomRatesInfo from "../../modules/hotels/hooks/useHotelGetRoomRatesInfo";
import HotelRoomRate from "../../modules/hotels/types/HotelRoomRate";
import HotelRoom from "../../modules/hotels/types/HotelRoom";

function PageHotel() {
    const {eventCityId} = useParams();
    const {hotelId} = useParams();
    const {languageCode} = useCustomerContext();
    const {eventHotelId} = useParams();
    const { dates: bookDates } = useBookingSearchContext();

    const bookFrom = bookDates.startDate?.format("DD/MM/YYYY") || null;
    const bookUntil = bookDates.endDate?.format("DD/MM/YYYY") || null;

    const eventCityQuery = useEventCityGet(eventCityId);
    const {data: eventCity} = eventCityQuery;

    const hotelQuery = useHotelGet(hotelId ? parseInt(hotelId) : 0);
    const {data: hotelData} = hotelQuery;

    const hotelInfoQuery = useHotelDetailsGet('/hotel_events/' + eventHotelId);
    const {data: hotelInfo} = hotelInfoQuery;

    const hotelFacilities = hotelData?.facilities[languageCode];

    const hotelCategoriesQuery = useHotelCategoriesGetAll(hotelData?.id, { execute: !!hotelData?.id });
    const {data: hotelCategories} = hotelCategoriesQuery;

    const hotelRoomsQuery = useHotelGetRoomsInfo(eventHotelId, bookFrom, bookUntil);
    const {data: hotelRooms} = hotelRoomsQuery;

    const hotelRoomsIds = hotelRooms?.map((room: HotelRoom) => room.id);

    const hotelRoomsRatesQuery = useHotelGetRoomRatesInfo(
        hotelRoomsIds,
        bookDates.startDate?.format('YYYY-MM-DD'),
        bookDates.endDate?.format('YYYY-MM-DD'),
        { execute: hotelRoomsIds !== undefined && hotelRoomsIds.length > 0 }
    )
    const {data: hotelRoomRates} = hotelRoomsRatesQuery;

    const hotelExtraInfo = hotelData?.goodToKnows[languageCode];

    return (
        <PublicLayout>
            {hotelInfo ?
                    <div className="nc-PageHome relative overflow-hidden">
                        {/* GLASSMOPHIN */}
                        <BgGlassmorphism/>

                        {/* SECTION HERO */}
                        {eventCity ?
                            <HotelSectionHero
                                mainImage={eventCity.bannerContentUrl}
                            />
                            : <Loader centerHorizontally />
                        }

                        {/* GALLERY */}
                        <HotelImagesGallery hotelId={hotelInfo.hotelObject.id} hotelImages={hotelInfo.images}/>

                        {/* MAIn */}
                        <main className="container relative z-10 mt-11 flex flex-col lg:flex-row ">
                            {/* CONTENT */}
                            <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10 mb-10">
                                {hotelInfo ?
                                    <HotelMainInfoCard hotel={hotelInfo.hotelObject}/>
                                    : <Loader centerHorizontally />
                                }
                                {hotelInfo ?
                                    <HotelCancellationPolicyCard eventHotelTranslation={hotelInfo}/>
                                    : <Loader centerHorizontally />
                                }
                                {hotelCategories ?
                                    <HotelAmenitiesCard hotelCategories={hotelCategories}/>
                                    : <Loader centerHorizontally />
                                }
                                {hotelFacilities ?
                                    <HotelInformationAndExtrasCard hotelFacilities={hotelFacilities}/>
                                    : <Loader centerHorizontally />
                                }
                                {hotelExtraInfo ?
                                    <HotelExtraInfoCard hotelExtraInfo={hotelExtraInfo}/>
                                    : <Loader centerHorizontally />
                                }
                                {hotelInfo && eventCity ?
                                    <HotelLocationCard hotel={hotelInfo.hotelObject} eventCity={eventCity}/>
                                    : <Loader centerHorizontally />
                                }
                            </div>

                            {/* SIDEBAR */}
                            <div className="flex-grow mt-14 lg:mt-0">
                                <div className="sticky top-28">
                                    {hotelRooms && hotelRoomRates ?
                                        hotelRooms.map((room: HotelRoom) => (
                                            <HotelRoomCard
                                                key={room.id}
                                                eventCityId={eventCityId}
                                                hotelRoom={room}
                                                roomPrice={
                                                    hotelRoomRates
                                                        .filter((roomRate: HotelRoomRate) => roomRate.roomHotelEvent === `/room_hotel_events/${room.id}`)
                                                        .reduce((acc: number, item: HotelRoomRate) => acc + item.loveRate, 0)
                                                }
                                                currencySymbol={hotelInfo?.currencySymbol}
                                            />
                                        ))
                                        : <Loader centerHorizontally />
                                    }
                                </div>
                            </div>

                        </main>
                    </div>
                : <Loader centerHorizontally />}
        </PublicLayout>
    );
}

export default PageHotel;
